export default {
  props: {
    borderRadius: {
      type: Boolean,
    },
    theme: {
      type: String,
    },
    image: {
      type: Object,
    },
    icon: {
      type: Object,
    },
    title: {
      type: String,
    },
    excerpt: {
      type: String,
    },
    button: {
      type: Object,
    },
  },
}
